export default __webpack_public_path__ + "static/media/boussole_aiguille_ENG.82a37bfe.png";